import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { bonuses, bonusesTotalValue } from '../data/bonuses';
import { OFFER_ANCHOR } from '../utils/links';
import { SectionHeading } from './SectionHeading';
function PriceTag({
  value,
  size = 'sm'
}: {
  value: string;
  size?: 'sm' | 'lg';
}) {
  return <p className="mt-4 flex flex-wrap items-center gap-2.5" data-id="element-57" data-mp="fteej0i979hs">
      <span className={`text-ink-mute line-through ${size === 'lg' ? 'text-[15px]' : 'text-[13.5px]'}`} data-id="element-58" data-mp="frtmbhjew2n3">
        {value}
      </span>
      <span className={`rounded-full bg-clay px-3 py-1 font-sans font-bold uppercase tracking-[0.12em] text-white ${size === 'lg' ? 'text-[11.5px]' : 'text-[10.5px]'}`} data-id="element-59" data-mp="5w8ozwpafqjo">
        Gratis
      </span>
    </p>;
}
export function Bonuses() {
  const [featured, ...rest] = bonuses;
  return <section className="bg-sage-tint" data-id="element-60" data-mp="1mai2fvrzruvq">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" style={{
      backgroundColor: "#FFFBF5",
      backgroundImage: "none"
    }} data-id="element-61" data-mp="1mbjoswegk3sr">
        <SectionHeading eyebrow="Regalo de lanzamiento" title={<>
              Y solo por hoy accedés <span className="text-clay" data-id="element-63" data-mp="3dfd0xeyzrsqr">GRATIS</span> a estos 5 bonus
            </>} subtitle="Recursos complementarios para aplicar lo aprendido, activar cada área de tu hogar y hacerle seguimiento a cada cambio." data-id="element-62" data-mp="3ie6h5f5nxxum" />

        <p className="mt-6 text-center text-[14px] text-ink-soft sm:text-[15px]" data-id="element-64" data-mp="3n4muz0deblhi">
          Valor real de los 5 bonus:{' '}
          <span className="text-ink-mute line-through" data-id="element-65" data-mp="2zglu8dmgl9cn">{bonusesTotalValue}</span>{' '}
          <span className="font-semibold text-sage-deep" data-id="element-66" data-mp="2uh96lqnrjy90">· hoy incluidos sin costo</span>
        </p>

        <div className="mx-auto mt-12 max-w-4xl sm:mt-16" data-id="element-67" data-mp="38gijohgoac8r">
          <article className="flex flex-col gap-7 rounded-3xl bg-white p-6 shadow-soft sm:flex-row sm:items-center sm:gap-10 sm:p-9" data-id="element-68" data-mp="38dw5hyza0yhk">
            <img src={featured.image} alt={featured.imageAlt} className="mx-auto w-full max-w-[260px] rounded-xl object-cover shadow-card sm:mx-0 sm:w-[270px] sm:max-w-none" loading="lazy" data-id="element-69" data-mp="np8bgi5e5djs" />
            <div className="text-center sm:text-left" data-id="element-70" data-mp="3cjfyzdkyarjg">
              <p className="eyebrow text-[10px] text-clay" data-id="element-71" data-mp="3cl0ub5f3aeid">{featured.tag} · el más completo</p>
              <h3 className="mt-2.5 font-display text-[23px] font-semibold leading-snug text-ink sm:text-[28px]" data-id="element-72" data-mp="3hg6gm5celv6z">
                {featured.title}
              </h3>
              <p className="mt-3 text-[14.5px] leading-[1.7] text-ink-soft sm:text-[15.5px]" data-id="element-73" data-mp="3qhmpg8nklp93">
                {featured.description}
              </p>
              <div className="flex justify-center sm:justify-start" data-id="element-74" data-mp="2tqlw3i0lqpvl">
                <PriceTag value={featured.value} size="lg" data-id="element-75" data-mp="2xujvlttua2p6" />
              </div>
            </div>
          </article>

          <ul className="mt-5 grid gap-5 sm:mt-6 sm:grid-cols-2" data-id="element-76" data-mp="32r0hehdkg4z3">
            {rest.map(bonus => <li key={bonus.tag} className="flex h-full gap-5 rounded-2xl bg-white p-5 shadow-card sm:p-6" data-id="element-77" data-mp="37l4px52hcl2a">
                <img src={bonus.image} alt={bonus.imageAlt} className="h-[130px] w-[92px] shrink-0 rounded-lg object-cover shadow-card sm:h-[140px] sm:w-[100px]" loading="lazy" data-id="element-78" data-mp="2a2d0sz3ri3rv" />
                <div className="flex flex-1 flex-col" data-id="element-79" data-mp="27jhqvzisk6p8">
                  <p className="eyebrow text-[9.5px] text-clay" data-id="element-80" data-mp="22kewd90ftivi">{bonus.tag}</p>
                  <h3 className="mt-2 font-display text-[17.5px] font-semibold leading-snug text-ink sm:text-[19px]" data-id="element-81" data-mp="1xltuz69g8t5h">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-[13px] leading-[1.6] text-ink-soft sm:text-[13.5px]" data-id="element-82" data-mp="1tjyrbv41q3oj">
                    {bonus.description}
                  </p>
                  <div className="mt-auto" data-id="element-83" data-mp="1ju5giwbq9slc">
                    <PriceTag value={bonus.value} data-id="element-84" data-mp="1jsca9i511adv" />
                  </div>
                </div>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-12 max-w-lg sm:mt-14" data-id="element-85" data-mp="19wrcxxawkyag">
          <a href={OFFER_ANCHOR} className="flex items-center justify-center gap-2.5 rounded-xl bg-sage-deep px-6 py-5 text-center text-[14px] font-semibold uppercase tracking-[0.09em] text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-sage sm:text-[15px]" data-id="element-86" data-mp="19u6c9bmccoea">
            Quiero la guía + los 5 bonus
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-87" data-mp="34y4c0nf2keeh" />
          </a>
          <p className="mt-4 text-center text-[12.5px] text-ink-mute" data-id="element-88" data-mp="2r8spnjgtl4l4">
            Incluidos sin costo adicional durante el lanzamiento
          </p>
        </div>
      </div>
    </section>;
}